var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { ResponseContentType } from '@angular/http';
import { SharedService } from './shared.service';
import { KeycloakService } from './keycloak.service';
import { HttpClientWrapper } from './httpClient';
var TasasService = (function (_super) {
    __extends(TasasService, _super);
    function TasasService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        return _this;
    }
    TasasService.prototype.generateToken = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "tasas/" + id + "/getToken";
        return this._http.get(wsUrl)
            .map(function (response) { return response.text(); });
    };
    TasasService.prototype.insert = function (tasas) {
        var wsUrl;
        wsUrl = this.urlSer() + 'tasas/insert/?data=' + btoa(SharedService.unescape(encodeURIComponent(tasas))) + '&usr=' + KeycloakService.getLoggedUser();
        //console.log('Tasas insert ' + wsUrl);
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    TasasService.prototype.generarCmp = function (tasas) {
        var wsUrl;
        wsUrl = this.urlSer() + "tasas/insert/?data=" + btoa(SharedService.unescape(encodeURIComponent(tasas))) + "&usr=" + KeycloakService.getLoggedUser();
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (res) {
            //console.log("GET COMPROBANTE");
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    TasasService.prototype.reimprimir = function (tasas) {
        var wsUrl;
        wsUrl = this.urlSer() + "tasas/reimprimir/?data=" + btoa(SharedService.unescape(encodeURIComponent(tasas)));
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (res) {
            //console.log("GET COMPROBANTE");
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    TasasService.prototype.generarCmpSinExp = function (tasas) {
        var wsUrl;
        wsUrl = this.urlSer() + "tasas/insertsinexp/?data=" + btoa(SharedService.unescape(encodeURIComponent(tasas))) + "&usr=" + KeycloakService.getLoggedUser();
        return this._http.get(wsUrl, {
            responseType: ResponseContentType.Blob
        }).map(function (res) {
            //console.log("GET COMPROBANTE");
            return new Blob([res.blob()], { type: 'application/pdf' });
        });
    };
    TasasService.prototype.findFechaImponible = function (id) {
        var wsUrl;
        wsUrl = this.urlSer() + "expediente/fechaImponible/" + id;
        //console.log("fecha imponible ws " + wsUrl);
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    TasasService.prototype.findLocalidadesIW = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = "app/data/" + "localidadIW.json";
        }
        else {
            wsUrl = this.urlSer() + "tasas/localidades/" + 2;
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    TasasService.prototype.getFechaHabil = function () {
        var wsUrl;
        if (this.isLocalData()) {
            wsUrl = "app/data/" + "localidadIW.json";
        }
        else {
            wsUrl = this.urlSer() + "tasas/nextFechaHabil";
        }
        return this._http.get(wsUrl)
            .map(function (response) { return response.json(); });
    };
    return TasasService;
}(SharedService));
TasasService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], TasasService);
export { TasasService };
//# sourceMappingURL=tasas.service.js.map